import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

import FormFieldGroup from './FormFieldGroup';

export default styled.div`
  margin: 0 auto;
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;

  ${media.moreThan('md')`
    flex-flow: row wrap;

    ${FormFieldGroup} {
      margin-bottom: initial;
      flex: 1;
      margin-right: 16px;

      &:last-of-type {
        margin-right: 40px;
      }

      + ${FormFieldGroup} {
        margin-left: 20px;
      }
    }
  `};
`;
